export const DietSizeMatrices = (json: IDietSizeMatrice): IDietSizeMatriceModel => {
	const { meal_size_id, meal_type, updated_at, created_at, ...rest } = json

	return {
		...rest,
		mealType: meal_type,
		mealSizeId: meal_size_id,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}
